import { Injectable } from '@angular/core';
import { last } from 'lodash';
import { ApiService } from '../../providers/api/api.service';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class AgentDownloadDialogService {
  isWizardVisible: BehaviorSubject<boolean>;
  isClickedFromUpdate: BehaviorSubject<boolean>;
  agentId: string = null;

  constructor(private readonly apiService: ApiService) {
    this.isWizardVisible = new BehaviorSubject(false);
    this.isClickedFromUpdate = new BehaviorSubject(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openDialog(agent: { item: any; isUpdateSuccess?: boolean } | any): void {
    this.agentId = agent?.item?.id ? agent.item.id : agent;
    this.isWizardVisible.next(true);
    this.isClickedFromUpdate.next(agent.isUpdateSuccess);
  }

  closeDialog(): void {
    this.agentId = null;
    this.isWizardVisible.next(false);
  }

  getFileExtensionFromURL(url: string): string {
    return last(url.split('.')).toLowerCase();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadAgentDetails(agentId: string): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(`/agent/v1/info/agent/${encodeURI(agentId)}`, {});
  }
}
